import { ScrollView } from 'react-native';
import styled from 'styled-components/native';

export const PlanMenuItemsContainer = styled(ScrollView)``;
